import { useEffect, useState } from "react";

// This module stores ONLY the user's light/dark theme preference — never any
// auth tokens or sensitive data. localStorage is the correct home for a UI
// preference that must survive full page reloads.
const KEY = "theme";
const listeners = new Set();

function currentTheme() {
  if (typeof window === "undefined") return "light";
  const stored = localStorage.getItem(KEY);
  if (stored === "dark" || stored === "light") return stored;
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function applyTheme(theme) {
  const root = document.documentElement;
  if (theme === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
  localStorage.setItem(KEY, theme);
  listeners.forEach((fn) => fn(theme));
}

if (typeof window !== "undefined") {
  applyTheme(currentTheme());
}

export function useTheme() {
  const [theme, setTheme] = useState(currentTheme);
  useEffect(() => {
    listeners.add(setTheme);
    return () => { listeners.delete(setTheme); };
  }, []);
  return {
    theme,
    toggle: () => applyTheme(theme === "dark" ? "light" : "dark"),
    setTheme: (t) => applyTheme(t),
  };
}
